import { createFormDataRequest } from "@/helpers/FormHelpers";
import { IFilters, IPaginateResponse } from "@/interfaces/Fetch";
import Note, { NoteForm } from "@/interfaces/Note";
import api from "../api";

export const instructorNoteApi = api.injectEndpoints({
  endpoints: (build) => ({
    getInstructorNotes: build.query<
      IPaginateResponse<Note>,
      [string, IFilters]
    >({
      query: ([id, data]) => {
        const params = createFormDataRequest(data);
        return {
          url: `/instructors/${id}/notes`,
          params,
        };
      },
      providesTags: (result, _error, _arg) =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: "InstructorNotes" as const,
                id,
              })),
              { type: "InstructorNotes", id: "LIST" },
            ]
          : [],
    }),
    storeInstructorNote: build.mutation<Note, [string, NoteForm]>({
      query: ([id, body]) => ({
        url: `/instructors/${id}/notes`,
        method: "POST",
        body,
      }),
      invalidatesTags: (_result, _error, [userId]) => [
        { type: "InstructorNotes", userId },
      ],
    }),
    deleteInstructorNote: build.mutation<void, [string, string]>({
      query: ([userId, noteId]) => ({
        url: `/instructors/${userId}/notes/${noteId}`,
        method: "DELETE",
      }),
      invalidatesTags: (_result, _error, [userId]) => [
        { type: "InstructorNotes", userId, id: "LIST" },
      ],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetInstructorNotesQuery,
  useDeleteInstructorNoteMutation,
  useStoreInstructorNoteMutation,
} = instructorNoteApi;
